module.exports = (__webpack_public_path__ || '') + "static/images/GooglePlayText-3ec2e035f00f9158f6f674037b1758d1.svg";